<template>
    <div v-if="Object.keys(filter).length > 0 && config.hasUserFilterPresets">
        <v-btn
            icon
            large
            elevation="2"
            class="mx-1 always-elevated-btn"
            @click.stop="menu = true"
        >
            <v-icon class="save-filter-icon" medium :color="theming.cardsAndTablesText || 'black'">
                mdi-content-save-outline
            </v-icon>
        </v-btn>
        <v-dialog v-model="menu" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Αποθήκευση Φίλτρου</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-text-field
                            v-model="filterName"
                            label="Όνομα Φίλτρου"
                            type="text"
                        ></v-text-field>
                        <span class="error-message">{{ errorMessage }}</span>
                    </v-container>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn class="mx-2 white--text" medium color="black" @click="saveFilterPreset" :disabled="filterName.length < 3">
                        <v-icon dark>mdi-content-save-outline</v-icon> ΥΠΟΒΟΛΗ
                    </v-btn>
                    <v-btn class="mx-2 white--text" medium color="red" @click="menu = false">
                        ΑΚΥΡΩΣΗ
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import userFilterPresetService from '@/services/userFilterPreset'
    export default {
        name: 'FilterPreset',
        props: {
            filter: {
                type: Object,
                required: true
            },
            sort: {
                type: Array,
                required: true
            }
        },
        computed: {
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            }
        },
        watch: {
            menu(newVal) {
                if (!newVal) {
                    this.filterName = ''
                    this.errorMessage = ''
                }
            }
        },
        data() {
            return {
                menu: false,
                filterName: '',
                errorMessage: ''
            }
        },
        methods: {
            saveFilterPreset() {
                const data = {
                    filter: this.filter,
                    name: this.filterName,
                    sort: this.sort
                }
                userFilterPresetService.save(data)
                    .then(() => {
                        this.menu = false
                        this.filterName = ''
                        this.$emit('filter-saved')
                    }).catch((error) => {
                        if (error?.response?.data?.code === 'FILTER_EXIST') {
                            this.errorMessage = 'Το φίλτρο υπάρχει ήδη με όνομα: ' + error?.response?.data?.message
                        } else if (error?.response?.data?.code === 'FILTER_NAME_EXIST') {
                            this.errorMessage = 'Υπάρχει φίλτρο με αυτό το όνομα'
                        } else {
                            this.errorMessage = 'Σφάλμα κατά την αποθήκευση του φίλτρου'
                        }
                    })
            }
        }
    }
</script>
<style scoped>
.error-message {
    color: red;
}
.save-filter-icon:hover {
    color: rgb(38, 38, 182) !important;
}
</style>
